/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-29 17:21:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-11-27 18:46:58
 */
import {
  Form,
  Col,
  Input,
  Modal,
  Row,
  notification,
  Checkbox,
  Button,
  message,
  Radio,
} from "antd"
import React, {
  ReactElement,
  useContext,
  useState,
  useEffect,
  useRef,
  useMemo,
} from "react"
import styles from "../payment/list/Payments.module.css"
import { unwrapResult } from "@reduxjs/toolkit"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../app/store"
import {
  detailPutstorage,
  getSplitTraceCodeMsfxAsync,
  getTraceableCodeSave,
} from "../putstorage/putstorageSlice"
import {
  ExclamationCircleOutlined,
} from "@ant-design/icons"
import { EditableColumnType, EditableList } from "../../compnents/list/EditableList"
import { getStorageTraceCodeCheckAsync, getStorageTraceCodeCheckMultyAsync, getUpdateMarkCodeAsync, getUpdateMarkCodeMultyAsync } from "./putstorelistSlice"
import { getStorageTraceCodeCheckMulty } from "../../services/storedetail"

const { Search } = Input

interface TraceCodePutstorageModalProps {
  showCodeInputModal: boolean
  paymentResult: any
  onCancel: () => void
  onOk: () => void
  grrkFlag?: boolean
  receiptsId?: any
  recipeItemId?: any
  storehouseTag?: boolean
  ybUploadFlag?: boolean
  receiptsType?:any
}

export const TraceCodePutStorageModal = ({
  showCodeInputModal,
  paymentResult,
  onCancel,
  onOk,
  grrkFlag = false,
  recipeItemId,
  receiptsId,
  storehouseTag,
  ybUploadFlag,
  receiptsType
}: TraceCodePutstorageModalProps): ReactElement => {
  const [items, setItems] = useState<any>([])

  const inputRef = useRef<any>(null)

  const inputCountRef = useRef<any>(null)

  const [data, setData] = useState<any>([])

  const [searchCode, setSearchCode] = useState<any>()

  const dispatch = useDispatch<RootDispatch>()

  const [currentMedicine, setCurrentMedicine] = useState<any>(null)

  const [messageApi, contextHolder] = message.useMessage()

  const [buttonLoading, setButtonLoading] = useState(false)

  const [repeatVisible, setRepeatVisible] = useState(false)

  const [inputMethodType, setInputMethodType] = useState('1')

  const [splitLoading, setSplitLoading] = useState(false)


  const [form] = Form.useForm()

  const [MethodForm] = Form.useForm()

  const currentCount = useMemo(() => {
    return data.reduce(
      (sum: number, item: any) => sum + (Number(item.count) || 0),
      0
    )
  }, [data])

  const columns: EditableColumnType<any>[] = [
    {
      title: "追溯码",
      align: "center",
      width: "10rem",
      dataIndex: "traceCode",
      ellipsis: true,
      render: (_, record) => {
        if(record?.codeLevel == 2){
          return record?.traceCode+"（中码）";
        }else if(record?.codeLevel == 3){
          return record?.traceCode+"（大码）";
        }else{
          return record?.traceCode;
        }

      },
    },
    {
      title: "数量",
      align: "center",
      width: "3rem",
      colSpan: 2,
      dataIndex: "count",
      ellipsis: true,
      editable: ybUploadFlag || receiptsType == 1 ? false : true,
      rules: [
        {
          required: true,
          message: "请输入数量",
        },
        {
          pattern: new RegExp(/^(0|[1-9]\d*)$/),
          message: "请输入数字",
        },
      ],
      onSave: (prev, next) => {
        const flag = currentMedicine?.count >= currentCount - Number(prev.count) + Number(next.count)
        if (!flag) {
          messageApi?.open({
            type: 'error',
            content: '采集数量不能大于入库数量',
            className: 'custom-class',
          })
          return
        }
        setData(
          data.map((item: any) =>
            item.traceCode == prev.traceCode
              ? {
                ...prev,
                ...next,
              }
              : item
          )
        )
      },
    },
    {
      title: "",
      align: "center",
      width: "3rem",
      colSpan: 0,
      dataIndex: "unit",
      render: (_, t) => {
        return currentMedicine?.splitTag == 1
          ? currentMedicine?.splitUnit
          : currentMedicine?.accountUnit
      },
    },
    {
      title: "操作",
      align: "center",
      width: "6rem",
      render: function Element(_: any, record: any) {
        const bigCode = record?.codeLevel == 2 || record?.codeLevel ==3;
        return (
          <div>
            {receiptsType == 1 ?
              <Button
                type="link"
                loading={splitLoading}
                disabled={!storehouseTag ? true : (!bigCode)?true : false}
                onClick={() => {
                  splitTraceCode();
                }}
              >
                {record?.codeLevel != 2 && record?.codeLevel !=3 ?'无需拆码':storehouseTag ? "一键拆码" : '登账后自动拆码'}
              </Button>
            :
              <Button
                type="link"
                danger
                onClick={() => {
                  setData(
                    data.filter(
                      (item: any) => item.traceCode != record.traceCode
                    )
                  )
                }}
              >
                删除
              </Button>
            }


          </div>
        )
      },
    },
  ]
  const splitTraceCode = () => {
    setSplitLoading(true);
    // 码上放心拆码
    if (grrkFlag) {
      dispatch(
        getSplitTraceCodeMsfxAsync({
          receiptsId: receiptsId
        })
      )
        .then(unwrapResult)
        .then((v: any) => {
          messageApi.open({
            type: 'success',
            content: `拆码成功`,
            className: 'custom-class',
            style: {
              marginTop: '35vh',
            },
          })
          // dispatch(detailPutstorage(receiptsId))
          onOk();
        }).finally(() => {
          setSplitLoading(false);
        })
    }
  }
  const saveTraceCodes = () => {
    // 购入入库保存
    if (grrkFlag) {
      const submitParam: any = data?.map((item: any) => {
        return {
          receiptsItemId: recipeItemId,
          receiptsId: receiptsId,
          traceCode: item.traceCode,
          count: item.count
        }
      })
      dispatch(
        getTraceableCodeSave({
          traceCodes: submitParam,
          receiptsId: receiptsId,
          isCheck: 0
        })
      )
        .then(unwrapResult)
        .then((v: any) => {
          onOk()
          setButtonLoading(false)
        })
    }
  }
  const checkTraceCode = (v: string, type: boolean, count = -1) => {

    const changeData = () => {
      if (type) {
        setData(
          data?.map((item: any) => {
            return item.traceCode == v
              ? { ...item, count: count ? Number(count) : Number(item.count || 0) + 1 }
              : item
          })
        )
      } else {
        setData([
          ...data,
          {
            traceCode: v,
            count: 1,
            unit:
              currentMedicine?.splitTag == 1
                ? currentMedicine?.splitUnit
                : currentMedicine?.accountUnit,
          },
        ])
      }
      inputRef.current?.focus()
      setSearchCode('')
    }

    const checkData = () => {
      dispatch(getStorageTraceCodeCheckAsync({ receiptsItemId: recipeItemId, traceCode: v }))
        .then(unwrapResult)
        .then(() => {
          changeData()
        })
        .catch((c: any) => {
          const errorData = c?.message?.split('####')?.[1]
          const errDataMain = errorData ? JSON.parse(errorData) : {}
          if (c?.message.startsWith("追溯码校验异常")) {
            Modal.confirm({
              title: '',
              icon: <ExclamationCircleOutlined />,
              okText: '确认无误',
              cancelText: '取消',
              content: (
                <div style={{ fontWeight: 'bold', marginTop: '-20px', fontSize: '16px' }}>
                  {errDataMain?.codeArray?.map((val: any, index?: any) => {
                    return <div key={index}>{val}</div>
                  })}
                  <div>{errDataMain?.errMsg}</div>
                </div>
              ),
              onOk: (() => {
                if (c?.message.includes('本次追溯码与上一次扫入的追溯码前')) {
                  dispatch(getUpdateMarkCodeAsync({ receiptsItemId: recipeItemId, traceCode: v }))
                    .then(unwrapResult)
                    .then(() => {
                      changeData()
                    })
                } else {
                  changeData()
                }
              }),
            })
          }
        })
    }

    if (v?.length > 0 && ((v?.indexOf("69") == 0 || v?.length != 20)) && count < 0) {
      Modal.confirm({
        title: '提示',
        okText: '确认无误，继续',
        content: (
          <p>
            以下追溯码：{v} 疑似扫错码，请再次确认是否正确。
          </p>
        ),
        onOk: () => {
          checkData()
        },
      })
    } else {
      checkData()
    }
  }

  const checkTraceCodeMulty = (v: string, count = -1) => {
    // 首先判断一下码是否正确
    const traceCodeList = v?.split(/\r?\n/)
    const traceCodes: string[] = [];
    traceCodeList.map((item: string) => {
      if (item?.trim().length > 0) {
        traceCodes.push(item.trim())
      }
    })
    const invalidCodes = traceCodeList?.filter((code: string) => code?.length > 0 && ((code?.indexOf("69") == 0 || code?.length != 20)))

    const changeDataMulty = () => {
      // 统计 traceCodes 中每个码出现的次数
      const codeCountMap: Record<string, number> = {}
      traceCodes.forEach((code: string) => {
        codeCountMap[code] = (codeCountMap[code] || 0) + 1
      })
      // 复制现有 data 并更新已存在的追溯码数量
      const updated = [...data]
      Object.keys(codeCountMap).forEach((code) => {
        const existIndex = updated.findIndex((item) => item.traceCode === code)
        if (existIndex >= 0) {
          // 已存在，累加数量
          updated[existIndex].count = Number(updated[existIndex].count) + Number(codeCountMap[code])
        } else {
          // 不存在，追加新记录
          updated.push({
            traceCode: code,
            count: Number(codeCountMap[code]),
            unit:
              currentMedicine?.splitTag == 1
                ? currentMedicine?.splitUnit
                : currentMedicine?.accountUnit,
          })
        }
      })
      setData([...updated])
      inputRef.current?.focus()
      setSearchCode('')
    }

    const checkDataMulty = (traceCodeList?: any) => {
      dispatch(getStorageTraceCodeCheckMultyAsync({ receiptsItemId: recipeItemId, traceCode: traceCodes }))
        .then(unwrapResult)
        .then(() => {
          changeDataMulty()
        })
        .catch((c: any) => {
          const errorData = c?.message?.split('####')?.[1]
          const errDataMain = errorData ? JSON.parse(errorData) : {}
          if (c?.message.startsWith("追溯码校验异常")) {
            Modal.confirm({
              title: '',
              icon: <ExclamationCircleOutlined />,
              okText: '确认无误',
              cancelText: '取消',
              content: (
                <div style={{ fontWeight: 'bold', marginTop: '-20px', fontSize: '16px', maxHeight: '460px', overflowY: 'auto' }}>
                  {errDataMain?.codeArray?.map((val: any, index?: any) => {
                    return <div key={index}>{val}</div>
                  })}
                  <div>{errDataMain?.errMsg}</div>
                </div>
              ),
              onOk: (() => {
                if (c?.message.includes('本次追溯码与上一次扫入的追溯码前')) {
                  dispatch(getUpdateMarkCodeMultyAsync({ receiptsItemId: recipeItemId, traceCode: traceCodeList }))
                    .then(unwrapResult)
                    .then(() => {
                      changeDataMulty()
                    })
                } else {
                  changeDataMulty()
                }
              }),
            })
          }
        })
    }

    if (invalidCodes.length > 0) {
      Modal.confirm({
        title: '提示',
        okText: '确认无误，继续',
        content: (
          <p style={{ maxHeight: '460px', overflowY: 'auto' }}>
            以下追溯码：{invalidCodes.join('\n')} 疑似扫错码，请再次确认是否正确。
          </p>
        ),
        onOk: () => {
          // 确认无误的情况下调取检测的接口
          checkDataMulty(traceCodeList)
        },
      })
    } else {
      checkDataMulty(traceCodeList)
    }

  }

  useEffect(() => {
    if (grrkFlag) {
      if (showCodeInputModal && paymentResult) {
        //入库选择账簿单位 拆零标志设置成0
        const paymentResultForRk = paymentResult.map((item: any) => {
          return {
            ...item,
            splitTag: 0,
          }
        })

        setItems(paymentResultForRk)
        setCurrentMedicine({ ...paymentResultForRk?.[0], count: paymentResultForRk?.[0]?.count || 0 })
        setData(paymentResultForRk?.[0]?.traceCodeList || [])
      } else {
        setItems([])
        setData([])
        setCurrentMedicine({})
      }
      //正常门诊扫码
    }
  }, [showCodeInputModal, grrkFlag, paymentResult])

  useEffect(() => {
    if (!showCodeInputModal) return
    if (inputRef) {
      const focusTimer = setTimeout(() => {
        inputRef.current?.focus()
      }, 100)
      return () => {
        if (focusTimer) {
          clearTimeout(focusTimer)
        }
      }
    }
  }, [inputRef, showCodeInputModal])

  useEffect(() => {
    const inputMethodType = localStorage.getItem('inputMethodType') && localStorage.getItem('inputMethodType') != 'null' && localStorage.getItem('inputMethodType') != 'undefined' ? localStorage.getItem('inputMethodType') || '1' : '1'
    if (showCodeInputModal) {
      localStorage.setItem('inputMethodType', inputMethodType || '1')
      MethodForm.setFieldsValue({
        inputMethod: inputMethodType || '1',
      })
      setInputMethodType(inputMethodType || '1')
    } else {
      setSearchCode('')
    }
  }, [showCodeInputModal])

  return (
    <>
      {contextHolder}
      <div>
        <Modal
          width={540}
          title='电子追溯码录入'
          maskClosable={false}
          visible={showCodeInputModal}
          onCancel={() => {
            onCancel()
            setButtonLoading(false)
          }}
          bodyStyle={{ height: '600px', overflowY: 'hidden' }}
          footer={
            <Row>
              <Col flex={1}>
                {ybUploadFlag || receiptsType == 1? (
                  <></>
                ) : (
                  <Button
                    onClick={() => {
                      onCancel()
                      setButtonLoading(false)
                    }}
                  >
                    取消
                  </Button>
                )}
                {ybUploadFlag || receiptsType == 1 ? (
                  <></>
                ) : (
                  <Button
                    type={'primary'}
                    loading={buttonLoading}
                    onClick={() => {
                      if (currentCount < currentMedicine?.count) {
                        Modal.confirm({
                          title: '追溯码采集风险提醒',
                          okText: '仍要继续',
                          cancelText: '去修改',
                          className: styles.modalConfirmContent,
                          content: (
                            <p>
                              {currentMedicine?.name}的采集数量必须等于入库数量
                            </p>
                          ),
                          onOk: () => {
                            if (data?.length) {
                              setButtonLoading(true)
                              saveTraceCodes()
                            } else {
                              messageApi?.open({
                                type: 'error',
                                content: '请先录入追溯码',
                                className: 'custom-class',
                              })
                            }

                          },
                          onCancel: () => {
                            setButtonLoading(false)
                          },
                        })
                      } else if (currentCount > currentMedicine?.count) {
                        messageApi?.open({
                          type: 'error',
                          content: '采集数量不能大于入库数量',
                          className: 'custom-class',
                        })
                        return
                      } else {
                        setButtonLoading(true)
                        saveTraceCodes()
                      }
                    }}
                  >
                    确认
                  </Button>
                )}
              </Col>
            </Row>
          }
          className={styles.traceCodePutstorageModal}
        >
          <Form form={MethodForm} className={styles.formItem}>
            <Form.Item label='录入方式' name='inputMethod'>
              <Radio.Group onChange={(v: any) => {
                setInputMethodType(v?.target?.value || '1')
                localStorage.setItem('inputMethodType', v?.target?.value || '1')
                setSearchCode('')
                setTimeout(() => {
                  inputRef.current?.focus()
                }, 100)
              }} disabled={ybUploadFlag || receiptsType == 1}>
                <Radio value='1'>单个录入</Radio>
                <Radio value='2'>批量录入</Radio>
              </Radio.Group>
            </Form.Item>
          </Form>
          {inputMethodType == '1' &&
            <Row className={styles.tips}>
              <Col span={24}>根据医保局最新的规定与要求：</Col>
              <Col span={24}>
                请在下方输入框中扫入每一盒药品包装上的电子追溯码。
              </Col>
              <Col span={24}>
                <span>包装</span>
                <span style={{ fontWeight: 'bold' }}>没有追溯码</span>
                <span>则不用扫入，系统会以</span>
                <span style={{ fontWeight: 'bold' }}>无码药品</span>
                <span>的方式上传。</span>
              </Col>
            </Row>
          }
          {/* {(!items?.length || items?.length == 0) && (
            <Row>
              <Col span={24} className={styles.errorMsg}>
                本次没有需要上传追溯码的药品。
              </Col>
            </Row>
          )} */}
          <Row>
            <Col
              span={24}
              className={styles.traceNameCol}
              style={{ color: '#333', fontWeight: 'bold' }}
            >
              {currentMedicine?.name} {currentMedicine?.count}
              {currentMedicine?.accountUnit}{' '}
              <span
                style={{
                  marginRight: '6px',
                }}
              >
                {currentMedicine?.packSpec}
              </span>{' '}
              <span
                style={{
                  marginRight: '6px',
                }}
              >
                {currentMedicine?.batchNo
                  ? '  批号：' + currentMedicine?.batchNo + ' '
                  : ' '}
              </span>
            </Col>
          </Row>
          {inputMethodType == '1' ?
            <Search
              ref={inputRef}
              placeholder='扫描/输入追溯码'
              allowClear
              value={searchCode}
              style={{ margin: '15px 0 10px' }}
              enterButton='添加 (回车)'
              disabled={ybUploadFlag || receiptsType == 1}
              onChange={(e) => {
                setSearchCode(e?.target?.value)
              }}
              onSearch={(v) => {
                const code = v?.trim()
                if (!code) return
                if (currentMedicine?.count <= currentCount) {
                  messageApi?.open({
                    type: 'error',
                    content: '追溯码已全部采集完成，无需再次采集',
                    className: 'custom-class',
                  })
                  setSearchCode('')
                  return
                }
                const currentData = data?.find(
                  (item: any) => item.traceCode == code
                )
                //检查有无重复数据
                if (currentData) {
                  form.setFieldsValue({
                    count: Number(currentData.count) + 1,
                  })
                  setRepeatVisible(true)
                  setTimeout(() => {
                    inputRef.current?.focus()
                  }, 100)
                } else {
                  checkTraceCode(code, false)
                }
              }}
            /> :
            <><Input.TextArea
              ref={inputRef}
              rows={5}
              autoSize={{ minRows: 5, maxRows: 5 }}
              placeholder={`每行一个追溯码；\n按回车键换行`}
              allowClear
              value={searchCode}
              style={{ margin: '15px 0 10px' }}
              disabled={ybUploadFlag || receiptsType ==1}
              onChange={(e) => {
                setSearchCode(e?.target?.value)
              }}
            />
              <Row style={{ display: 'flex', justifyContent: 'center', margin: '10px 0' }}>
                <Button type='primary' ghost style={{ marginRight: '10px' }} onClick={() => {
                  setTimeout(() => {
                    inputCountRef?.current?.focus()
                  }, 500)
                  setSearchCode('')
                }}>清空</Button>
                <Button type='primary' onClick={(() => {
                  const code = searchCode
                  if (!code) return
                  if (currentMedicine?.count <= currentCount) {
                    messageApi?.open({
                      type: 'error',
                      content: '追溯码已全部采集完成，无需再次采集',
                      className: 'custom-class',
                    })
                    setSearchCode('')
                    return
                  }

                  const lines = searchCode.split(/\r?\n/).filter((line: string) => line.trim() !== '')
                  const searchCodeList = lines.join('\n')
                  if ((lines?.length + currentCount) > currentMedicine?.count) {
                    messageApi?.open({
                      type: 'error',
                      content: '采集数量不能大于入库数量',
                      className: 'custom-class',
                    })
                    return
                  } else {
                    checkTraceCodeMulty(searchCodeList)
                  }
                  // const currentData = data?.find(
                  //   (item: any) => item.traceCode == code
                  // )
                })}>添加</Button>
              </Row></>}
          <Row style={{ marginBottom: 5 }}>
            <Col>
              应采：
              <span style={{ color: '#31CB7B' }}>
                {currentMedicine?.count}{currentMedicine?.accountUnit}
              </span>
              ，实采：
              <span
                style={{
                  color:
                    currentMedicine?.count > currentCount
                      ? '#ff4d4f'
                      : '#FAA038',
                }}
              >
                {currentCount}{currentMedicine?.accountUnit}
              </span>
            </Col>
          </Row>
          <Row style={{ marginBottom: 5 ,color:"gray",fontStyle:"italic"}}>
            {receiptsType == 1 ? '注：码上放心对接的商品不可修改追溯码，且中大码会在登账后自动转成小码':''}
          </Row>
          <EditableList
            bordered
            // loading={pageLoading}
            style={{ maxHeight: '400px' }}
            scroll={data?.length ? { y: inputMethodType == '1' ? '18rem' : '15rem' } : {}}
            columns={
              ybUploadFlag
                ? columns?.filter((v: any) => v.title != '操作')
                : columns
            }
            rowClassName={() => 'editable-row'}
            rowKey={(t: any) => t.id}
            dataSource={data}
          />
        </Modal>

        <Modal
          width={450}
          title='采集相同追溯码'
          visible={repeatVisible}
          onOk={() => form.submit()}
          onCancel={() => {
            setRepeatVisible(false)
          }}
        >
          <Form
            form={form}
            onFinish={(vs) => {
              if (inputMethodType == '1') {
                const currentData = data?.find(
                  (item: any) => item.traceCode == searchCode?.trim()
                )
                if (
                  currentMedicine?.count >=
                  currentCount - currentData.count + Number(vs.count)
                ) {
                  setRepeatVisible(false)
                  checkTraceCode(searchCode?.trim(), true, vs.count)
                } else {
                  messageApi?.open({
                    type: 'error',
                    content: '采集数量不能大于入库数量',
                    className: 'custom-class',
                  })
                  return
                }
              } else {
                return
              }
            }
            }
          >
            <Row>
              <Col span={24}>
                <Form.Item label='追溯码'>
                  <span style={{ fontSize: 18, fontWeight: 'bold' }}>
                    {searchCode?.trim()}
                  </span>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label='药品名称'>
                  {currentMedicine?.name} {currentMedicine?.count}
                  {currentMedicine?.splitTag == 1
                    ? currentMedicine?.splitUnit
                    : currentMedicine?.accountUnit}{' '}
                  <span
                    style={{
                      marginRight: '6px',
                    }}
                  >
                    {currentMedicine?.packSpec}
                  </span>
                </Form.Item>
              </Col>
              <Col span={24} style={{ display: 'flex' }}>
                <Form.Item
                  label='采集数量'
                  name='count'
                  rules={[
                    {
                      required: true,
                      message: '请输入采集数量',
                    },
                    {
                      pattern: new RegExp(/^(0|[1-9]\d*)$/),
                      message: '请输入数字',
                    },
                  ]}
                >
                  <Input
                    ref={inputCountRef}
                    allowClear
                    style={{ width: 120, marginRight: 8 }}
                  // onChange={(e) => {
                  // }}
                  />
                  {/* 个 */}
                </Form.Item>
                <span style={{ paddingTop: 6 }}>个</span>
              </Col>
            </Row>
          </Form>
        </Modal>
      </div>
    </>
  )
}
